export const UPLOAD_AGREEMENT = "UPLOAD_AGREEMENT"
export const UPLOAD_AGREEMENT_SUCCESS = "UPLOAD_AGREEMENT_SUCCESS"
export const UPLOAD_AGREEMENT_FAILED = "UPLOAD_AGREEMENT_FAILED"


export const GET_NDA_AGREEMENT = "GET_NDA_AGREEMENT"
export const GET_NDA_AGREEMENT_SUCCESS = "GET_NDA_AGREEMENT_SUCCESS"
export const GET_NDA_AGREEMENT_FAILED = "GET_NDA_AGREEMENT_FAILED"

export const SEND_AGREEMENT_MAIL = "SEND_AGREEMENT_MAIL"
export const SEND_AGREEMENT_MAIL_SUCCESS = "SEND_AGREEMENT_MAIL_SUCCESS"
export const SEND_AGREEMENT_MAIL_FAILED = "SEND_AGREEMENT_MAIL_FAILED"